// --------------------引入请求方式


import {
  get,
  get1,
  get2,
  post,
  Delete,
  put
} from './http'
export const articlesList = get('/cms/articles/list') //文章列表
export const articlesDetails = get('/cms/articles/view') //文章详情
export const agentApply = post('/cms/agent/apply') //申请合作

//--------------------导出api
